import { SxProps, Theme } from '@mui/material';

/** Separation between the home delivery text and the tag, beyond the card's own gap. */
const EXTRA_GAP = 10;

/**
 * Occupies the Compare slot. XS-SM (AC5): a normal row below the delivery labels,
 * so the card grows. MD-XL (AC3): the same 15px Compare reserves, with the tag
 * positioned absolutely inside it so the card keeps its current height.
 */
export const slotSx: SxProps<Theme> = (theme: Theme) => ({
	display: 'flex',
	flexShrink: 0,
	// Extra separation from the home delivery text, on top of the card's 10px gap.
	marginTop: `${EXTRA_GAP}px`,

	[theme.breakpoints.up('md')]: {
		position: 'relative',
		height: '15px',
		marginTop: 0,
	},
});

/** Placement only; the tag's own look comes from the shared `SameDayTag`. */
export const tagPlacementSx: SxProps<Theme> = (theme: Theme) => ({
	[theme.breakpoints.up('md')]: {
		position: 'absolute',
		left: 0,
		// Hangs below the slot by the extra gap instead of pushing the actions down,
		// so the card keeps its height (AC3); it lands in the space reserved for the
		// minimum-quantity line underneath.
		bottom: `-${EXTRA_GAP}px`,
	},
});
